export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
